import { useMemo } from 'react';
import { QuestionmarkCircle, WaterIcon } from '../../../shared/assets/icons';
import { h1Style, p1Style } from '../../../shared/styles/text';
import { sourceLabels } from '../../../shared/types/enums';
import {
  Account,
  Pedestal,
  SourceStatusEnum,
  Valve,
} from '../../../shared/types/server-types';
import {
  iconStyle,
  modalHeaderStyle,
  sourceInfoStyle,
  statusSignalsStyle,
} from './modal-styles';

interface IValveModalProps {
  valve: Valve;
  pedestal: Pedestal;
  account: Account;
}

export const ValveModalContent = (props: IValveModalProps): JSX.Element => {
  const { valve, pedestal, account } = props;
  const { status, position, type } = valve;
  const { identifier, location } = pedestal;
  const { constants: locationConstants } = location;
  const { waterTariff, specialTariffs } = account;

  const tariff = useMemo(() => {
    if (specialTariffs) {
      const tariff = specialTariffs[location.id];
      return tariff ? tariff.waterTariff : 0;
    }
    return waterTariff
      ? waterTariff
      : locationConstants
        ? locationConstants.waterTariff
        : 0;
  }, [locationConstants, waterTariff]);

  return (
    <>
      <div className={modalHeaderStyle}>
        <div>
          <p className={p1Style}>{identifier.toUpperCase()}</p>
          <h1 className={h1Style}>
            {sourceLabels[type]} {position}
          </h1>
        </div>
        <WaterIcon className={iconStyle} />
      </div>
      <div className={statusSignalsStyle(valve)}>
        <span id="available">
          {status === SourceStatusEnum.AVAILABLE
            ? 'available'
            : 'not available'}
        </span>
        <QuestionmarkCircle
          title="A valve can be activated while it is not in use by someone else."
          aria-label="A valve can be activated while it is not in use by someone else."
        />
      </div>
      <div className={sourceInfoStyle}>
        <div>
          <label>tariff</label>
          <p style={{ textTransform: 'none' }}>{tariff} EUR/m³</p>
        </div>
        <div>
          <label>Connection size</label>
          <p>{valve.connectionSize} inch</p>
        </div>
      </div>
    </>
  );
};
